import { Component, OnInit, OnDestroy, ViewEncapsulation, ComponentFactoryResolver, ChangeDetectorRef } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormController } from '../../controllers/FormController';
import { ConfirmationService } from 'primeng/api';
import { ToastrService } from 'ngx-toastr';
import { IEntityOptions, IFormOptions, IGridOptions } from '../../interfaces/IEntity';
import { MatDialog } from '@angular/material/dialog';
import { NestedNavigationService } from '../../../services/nested-navigation/nested-navigation.service';
import { BreadCrumbsService } from '../../../services/bread-crumbs/bread-crumbs.service';
import { ToolbarActionsService } from '../../../services/toolbar-actions/toolbar-actions.service';

export interface IDetailComponent {
	displayName: string;
	component?: any;
	isHidden?: boolean;
	index?: number;
	isMenuHidden?: boolean | Function;
	click?: Function;
	bladeIndexToNavigateTo?: number;
	menuHidden?: boolean;
	getDataEvenIfIsMenuHidden?: boolean;
	icon?: string;
	entityOptions?: IEntityOptions;
	formOptions?: IFormOptions;
	gridOptions?: IGridOptions;
	context?: any;
	listIndex?: number;
  entityData?: any;
  customEntityId?: any;
}

export interface IButtonAction {
	text?: string;
	iconClass?: string;
	click?: Function;
	tooltip?: string;
  hidden?: any;
  dropdownGroup?: string;
  disabled?: Function;
}


@Component({
	selector: 'app-mf-blade',
	templateUrl: './mf-blade.component.html',
	styles: [':host {display: block !important;}'],
	//styleUrls: ['@framework/components/mf-blade/mf-blade.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class MfBladeComponent extends FormController implements OnInit, OnDestroy {
  constructor(apiService?: ApiService,
    route?: ActivatedRoute,
    componentFactoryResolver?: ComponentFactoryResolver,
    messageService?: ToastrService,
    confirmationService?: ConfirmationService,
    dialogService?: MatDialog,
    auth?: IdentityAuthService,
    nestedNavigationService?: NestedNavigationService,
    breadCrumbService?: BreadCrumbsService,
    toolbarActionService?: ToolbarActionsService,
    cdr?: ChangeDetectorRef) {
    super(apiService, route, componentFactoryResolver, messageService, confirmationService, dialogService, auth, nestedNavigationService, breadCrumbService, cdr, toolbarActionService);
	}
}
